<template>
  <div class="ergebnis-view">
    <div v-if="!tarife" class="ergebnis-empty">
      <div class="ergebnis-empty__inner">
        <v-icon
          icon="mdi-magnify-close"
          size="36"
          color="grey-darken-1"
          class="mb-2"
        />
        <h2 class="ergebnis-empty__title">
          Keine beantragbaren Zusatzversicherungen gefunden
        </h2>
        <a
          class="ergebnis-empty__link"
          @click="berechnungStore.setShowPop(false, 'annahmecheck')"
        >
          warum manche Tarife nicht abschließbar sind →
        </a>
      </div>
    </div>

    <template v-else>
      <VergleichHeader
        v-if="!sharedDataStore.isMobile() && tarife.length > 0"
        :componentKeyStatus="componentKeyStatus"
        :berechnung="berechnung"
        :vergleichCount="vergleichCount"
      />
      <VergleichHeaderMobil
        v-if="sharedDataStore.isMobile() && tarife.length > 0"
        :componentKeyStatus="componentKeyStatus"
        :berechnung="berechnung"
        :vergleichCount="vergleichCount"
      />
      <WechselVergleich
        :componentKeyStatus2="componentKeyStatus2"
        :tarif="wechselTarif"
        v-if="
          !sharedDataStore.isMobile() &&
          wechselTarif.tarif_id > 0 &&
          berechnung.ber_segment <= 1 &&
          berechnung.ber_wechsel_tarif_id > 0
        "
      />

      <div class="ergebnis-list">
        <template v-for="t in tarife" :key="t.tarif_id">
          <CardBig
            v-if="!sharedDataStore.isMobile()"
            :componentKeyStatus="componentKeyStatus"
            :tarif="t"
            :berechnung="berechnung"
          />
          <CardSmall
            v-else
            :componentKeyStatus="componentKeyStatus"
            :tarif="t"
            :berechnung="berechnung"
          />
        </template>
      </div>
    </template>

    <v-dialog
      v-model="berechnungStore.tarif.showPopYes"
      :width="sharedDataStore.isMobile() ? '100%' : berechnungStore.tarif.dialogWidth || 1000"
      :fullscreen="sharedDataStore.isMobile()"
      scrollable
    >
      <v-card rounded="0" class="pop-card">
        <div class="pop-card__head">
          <span class="pop-card__brand">
            <span class="pop-card__brand-dot"></span>
            <span class="brand-mark">WaizmannVergleich</span>
          </span>
          <v-btn
            icon
            variant="text"
            density="comfortable"
            class="pop-card__close"
            @click="berechnungStore.closePop(berechnungStore.tarif)"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <SofortPop
          :componentKeyStatus="componentKeyStatus"
          v-if="berechnungStore.tarif.showPopType == 'sofortpop'"
          :tarif="berechnungStore.tarif"
        />
        <VergleichKinder
          :componentKeyStatus="componentKeyStatus"
          v-if="berechnungStore.tarif.showPopType == 'vergleichkinder'"
          :tarif="berechnungStore.tarif"
          :alletarife="tarife"
        />
        <VergleichLuecke
          :componentKeyStatus="componentKeyStatus"
          v-if="berechnungStore.tarif.showPopType == 'vergleichluecke'"
          :tarif="berechnungStore.tarif"
          :alletarife="tarife"
          :berechnung="berechnung"
        />
        <KinderWert
          :componentKeyStatus="componentKeyStatus"
          v-if="berechnungStore.tarif.showPopType == 'kinderwert'"
          :tarif="berechnungStore.tarif"
        />
        <ClearmentSchutz
          :componentKeyStatus="componentKeyStatus"
          v-if="berechnungStore.tarif.showPopType == 'vertragsschutz'"
          :tarif="berechnungStore.tarif"
        />
        <WaizmannWert
          :componentKeyStatus="componentKeyStatus"
          v-if="berechnungStore.tarif.showPopType == 'waizmannwert'"
          :tarif="berechnungStore.tarif"
          :berechnung="berechnung"
        />

        <ClearmentLsk
          :componentKeyStatus="componentKeyStatus"
          v-if="berechnungStore.tarif.showPopType == 'clearmentlsk'"
          :tarif="berechnungStore.tarif"
        />
        <BeitragsEntwicklung
          :componentKeyStatus="componentKeyStatus"
          v-if="berechnungStore.tarif.showPopType == 'beitragsentwicklung'"
          :tarif="berechnungStore.tarif"
          :alletarife="tarife"
        />
        <AnnahmeCheck
          :componentKeyStatus="componentKeyStatus"
          v-if="berechnungStore.tarif.showPopType == 'annahmecheck'"
          :berechnung="berechnung"
          :vergleichCount="vergleichCount"
          :notarife="notarife"
        />
        <AnnahmeKriterien
          :componentKeyStatus="componentKeyStatus"
          v-if="berechnungStore.tarif.showPopType == 'annahmekriterien'"
          :berechnung="berechnung"
        />
        <HightechVergleich
          :componentKeyStatus="componentKeyStatus"
          v-if="berechnungStore.tarif.showPopType == 'vergleichhightech'"
          :tarif="berechnungStore.tarif"
          :alletarife="tarife"
        />
        <SchnellVergleich
          :componentKeyStatus="componentKeyStatus"
          v-if="
            berechnungStore.tarif.showPopType == 'schnellvergleich' &&
            berechnung.ber_segment <= 1
          "
          :berechnung="berechnung"
          :tarif="berechnungStore.tarif"
          :alletarife="tarife"
        />
        <SchnellVergleichBrille
          :componentKeyStatus="componentKeyStatus"
          v-if="
            berechnungStore.tarif.showPopType == 'schnellvergleich' &&
            berechnung.ber_segment == 2
          "
          :tarif="berechnungStore.tarif"
          :alletarife="tarife"
        />
        <SchnellVergleichHeil
          :componentKeyStatus="componentKeyStatus"
          v-if="
            berechnungStore.tarif.showPopType == 'schnellvergleich' &&
            berechnung.ber_segment == 3
          "
          :tarif="berechnungStore.tarif"
          :alletarife="tarife"
        />
        <SchnellVergleichKrank
          :componentKeyStatus="componentKeyStatus"
          v-if="
            berechnungStore.tarif.showPopType == 'schnellvergleich' &&
            berechnung.ber_segment == 4
          "
          :tarif="berechnungStore.tarif"
          :alletarife="tarife"
        />
        <DreiVergleichZahn
          :componentKeyStatus="componentKeyStatus"
          v-if="
            berechnungStore.tarif.showPopType == 'dreivergleich' &&
            berechnung.ber_segment <= 1
          "
          :tarif1="berechnungStore.tarif"
          :alletarife="tarife"
          :berechnung="berechnung"
        />
        <DreiVergleichBrille
          :componentKeyStatus="componentKeyStatus"
          v-if="
            berechnungStore.tarif.showPopType == 'dreivergleich' &&
            berechnung.ber_segment == 2
          "
          :tarif1="berechnungStore.tarif"
          :alletarife="tarife"
          :berechnung="berechnung"
        />
        <DreiVergleichHeil
          :componentKeyStatus="componentKeyStatus"
          v-if="
            berechnungStore.tarif.showPopType == 'dreivergleich' &&
            berechnung.ber_segment == 3
          "
          :tarif1="berechnungStore.tarif"
          :alletarife="tarife"
          :berechnung="berechnung"
        />
        <AlleBerechnungen
          :componentKeyStatus="componentKeyStatus"
          v-if="berechnungStore.tarif.showPopType == 'alleberechnungen'"
        />
        <DreiVergleichKrank
          :componentKeyStatus="componentKeyStatus"
          v-if="
            berechnungStore.tarif.showPopType == 'dreivergleich' &&
            berechnung.ber_segment == 4
          "
          :tarif1="berechnungStore.tarif"
          :alletarife="tarife"
          :berechnung="berechnung"
        />
        <BerechnungTeilen
          :componentKeyStatus="componentKeyStatus"
          v-if="berechnungStore.tarif.showPopType == 'berechnungteilen'"
          :berechnung="berechnung"
        />

        <ZahnfehlstellungNicht
          :componentKeyStatus="componentKeyStatus"
          v-if="berechnungStore.tarif.showPopType == 'zahnfehlstellungnicht'"
          :berechnung="berechnung"
        />
        <KfoNicht
          :componentKeyStatus="componentKeyStatus"
          v-if="berechnungStore.tarif.showPopType == 'kfonichtmehr'"
          :berechnung="berechnung"
        />
        <LaufendeBehandlung
          :componentKeyStatus="componentKeyStatus"
          v-if="berechnungStore.tarif.showPopType == 'laufendebehandlung'"
          :berechnung="berechnung"
        />
        <KeineTarifeLaufendeBehandlung
          :componentKeyStatus="componentKeyStatus"
          v-if="
            berechnungStore.tarif.showPopType == 'keinetarifelaufendebehandlung'
          "
          :berechnung="berechnung"
        />
        <FamilienVersicherung
          :componentKeyStatus="componentKeyStatus"
          v-if="berechnungStore.tarif.showPopType == 'familienversicherung'"
          :berechnung="berechnung"
        />
        <ParoEmpfehlung
          :componentKeyStatus="componentKeyStatus"
          v-if="berechnungStore.tarif.showPopType == 'paroempfehlung'"
          :berechnung="berechnung"
        />
        <BegrenzungInfo
          :componentKeyStatus="componentKeyStatus"
          v-if="berechnungStore.tarif.showPopType == 'begrenzungzahn'"
          :tarif="berechnungStore.tarif"
          :berechnung="berechnung"
        />
        <BegrenzungRumpfjahr
          :componentKeyStatus="componentKeyStatus"
          v-if="berechnungStore.tarif.showPopType == 'begrenzungrumpfjahr'"
          :tarif="berechnungStore.tarif"
          :berechnung="berechnung"
        />
        <PrivateKranken
          :componentKeyStatus="componentKeyStatus"
          v-if="berechnungStore.tarif.showPopType == 'privatekranken'"
          :berechnung="berechnung"
        />
        <WechselSinnvoll
          :componentKeyStatus="componentKeyStatus"
          v-if="berechnungStore.tarif.showPopType == 'wechsel'"
          :berechnung="berechnung"
        />
        <WechselBehandlung
          :componentKeyStatus="componentKeyStatus"
          v-if="berechnungStore.tarif.showPopType == 'wechselbehandlung'"
          :berechnung="berechnung"
        />
        <TarifBeschreibung
          :componentKeyStatus="componentKeyStatus"
          v-if="berechnungStore.tarif.showPopType == 'tarifbeschreibung'"
          :tarif="berechnungStore.tarif"
          :berechnung="berechnung"
        />
      </v-card>
    </v-dialog>
  </div>
</template>

<script setup>
  import { ref, watch, onMounted, getCurrentInstance } from "vue";
  import { useRoute } from "vue-router";
  import BaseCalls from "@/services/BaseCalls";
  import { useLoaderStore } from "@/stores/loaderStore";
  import BerechnungTeilen from "@/components/tarif/vergleich/BerechnungTeilen";
  import BeitragsEntwicklung from "@/components/tarif/info/BeitragsEntwicklung";
  import ClearmentSchutz from "@/components/tarif/info/ClearmentSchutz";
  import ClearmentLsk from "@/components/tarif/info/ClearmentLsk";
  import KinderWert from "@/components/tarif/zahn/KinderWert";
  import SofortPop from "@/components/tarif/zahn/SofortPop";
  import CardBig from "@/components/tarif/layouts/CardBig";
  import CardSmall from "@/components/tarif/layouts/CardSmall";
  import TarifBeschreibung from "@/components/tarif/layouts/TarifBeschreibung";
  import DreiVergleichZahn from "@/components/tarif/vergleich/zahn/DreiVergleich";
  import DreiVergleichBrille from "@/components/tarif/vergleich/brille/DreiVergleich";
  import DreiVergleichHeil from "@/components/tarif/vergleich/heil/DreiVergleich";
  import DreiVergleichKrank from "@/components/tarif/vergleich/krank/DreiVergleich";
  import VergleichKinder from "@/components/tarif/vergleich/zahn/VergleichKinder";
  import VergleichLuecke from "@/components/tarif/vergleich/zahn/VergleichLuecke";
  import ZahnfehlstellungNicht from "@/components/tarif/vergleich/zahn/ZahnfehlstellungNicht";
  import KfoNicht from "@/components/tarif/vergleich/zahn/KfoNicht";
  import LaufendeBehandlung from "@/components/tarif/vergleich/zahn/LaufendeBehandlung";
  import KeineTarifeLaufendeBehandlung from "@/components/tarif/vergleich/zahn/KeineTarifeLaufendeBehandlung";
  import WechselSinnvoll from "@/components/tarif/vergleich/zahn/WechselSinnvoll";
  import WechselBehandlung from "@/components/tarif/vergleich/zahn/WechselBehandlung";
  import SchnellVergleich from "@/components/tarif/vergleich/zahn/SchnellVergleich";
  import SchnellVergleichBrille from "@/components/tarif/vergleich/brille/SchnellVergleich";
  import SchnellVergleichHeil from "@/components/tarif/vergleich/heil/SchnellVergleich";
  import SchnellVergleichKrank from "@/components/tarif/vergleich/krank/SchnellVergleich";
  import FamilienVersicherung from "@/components/tarif/vergleich/zahn/FamilienVersicherung";
  import ParoEmpfehlung from "@/components/berechnung/vergleich/zahn/ParoEmpfehlung";
  import BegrenzungInfo from "@/components/berechnung/vergleich/zahn/BegrenzungInfo";
  import HightechVergleich from "@/components/tarif/vergleich/zahn/HightechVergleich";
  import PrivateKranken from "@/components/tarif/vergleich/zahn/PrivateKranken";
  import VergleichHeader from "@/components/tarif/vergleich/VergleichHeader";
  import VergleichHeaderMobil from "@/components/tarif/vergleich/VergleichHeaderMobil";
  import AnnahmeCheck from "@/components/tarif/vergleich/AnnahmeCheck";
  import AnnahmeKriterien from "@/components/tarif/vergleich/AnnahmeKriterien";
  import WaizmannWert from "@/components/tarif/vergleich/WaizmannWert";
  import BegrenzungRumpfjahr from "@/components/tarif/vergleich/BegrenzungRumpfjahr";
  import AlleBerechnungen from "@/components/berechnung/vergleich/AlleBerechnungen";
  import WechselVergleich from "@/components/berechnung/vergleich/WechselVergleich";
  import { useSharedDataStore } from "@/stores/sharedData";
  import { useBerechnungStore } from "@/stores/berechnung";
  const berechnungStore = useBerechnungStore();
  const sharedDataStore = useSharedDataStore();
  const { proxy } = getCurrentInstance();

  const loaderStore = useLoaderStore();
  const route = useRoute();
  const tarife = ref([]);
  const notarife = ref([]);
  const componentKeyStatus = ref(0);
  const componentKeyStatus2 = ref(0);
  const vergleichCount = ref({
    notarifeCount: 0,
    vergleichCount: 0,
  });
  const isLoaded = ref(false);
  const berechnung = ref(false);
  const wechselTarif = ref(false);

  function setLoading(loading) {
    loaderStore.setLoader(loading);
  }

  async function getVergleich(token) {
    let berSelect = {};
    berSelect.action = "getVergleichToken";
    berSelect.ber_identity_token = token;
    try {
      const resp = await BaseCalls.postVergleich(berSelect);
      if (resp.data && resp.data.berechnung) {
        tarife.value = resp.data.tarife;
        berechnung.value = resp.data.berechnung;
        notarife.value = resp.data.notarife;
        vergleichCount.value.tarifeCount = resp.data.tarifeCount;
        vergleichCount.value.notarifeCount = resp.data.notarifeCount;
        berechnungStore.setBerechnung(resp.data.berechnung);
        if (
          resp.data.berechnung.ber_segment <= 1 &&
          resp.data.berechnung.ber_wechsel_tarif_id > 0
        ) {
          getWechselTarif(resp.data.berechnung.ber_wechsel_tarif_id);
        }
        componentKeyStatus.value = componentKeyStatus.value + 1;
        if (resp.data.berechnung.ber_id !== 0) {
          isLoaded.value = true;
        }
        setLoading(false);
      }
    } catch (err) {
      console.log("error berechnung");
    }
  }

  async function getWechselTarif(tarif_id) {
    let select = {};
    select.tarif_id = tarif_id;
    select.ber_identity_token = berechnung.value.ber_identity_token;
    select.action = "getTarifAntragBerechnung";

    try {
      const resp = await BaseCalls.postTarif(select);
      if (resp.data && resp.data.tarif) {
        wechselTarif.value = resp.data.tarif;
        componentKeyStatus2.value = componentKeyStatus2.value + 1;
      } else {
        select.action = "getZahnTarifId";
        const resp = await BaseCalls.postTarif(select);
        if (resp.data && resp.data.tarif) {
          wechselTarif.value = resp.data.tarif;
          componentKeyStatus2.value = componentKeyStatus2.value + 1;
        }
      }
    } catch (err) {
      console.log("error tarife");
    }
  }

  watch(
    () => route.params.token,
    async (newToken, oldToken) => {
      if (newToken !== oldToken) {
        setLoading(true);
        await getVergleich(newToken);
      }
    },
    { immediate: true }
  );

  onMounted(() => {
    berechnungStore.setShowFooter(false);
    proxy.$updateDocumentHead("Ergebnis", "Ergebnis");
  });
</script>

<style scoped>
  .ergebnis-view {
    width: 100%;
    max-width: 1100px;
    margin: 0 auto;
  }

  .ergebnis-list {
    display: flex;
    flex-direction: column;
    gap: 0;
  }

  .ergebnis-empty {
    background: #ffffff;
    border: 1px dashed #d8dde5;
    border-radius: 3px;
    padding: 32px 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 280px;
  }
  .ergebnis-empty__inner {
    text-align: center;
    max-width: 480px;
  }
  .ergebnis-empty__title {
    font-size: 16px;
    font-weight: 700;
    color: #0f172a;
    margin: 0 0 6px;
  }
  .ergebnis-empty__link {
    font-size: 13px;
    color: #0f4c81;
    font-weight: 600;
    cursor: pointer;
    text-decoration: none;
  }
  .ergebnis-empty__link:hover {
    text-decoration: underline;
  }

  .pop-card {
    border: 1px solid #d8dde5;
    border-top: 3px solid #0f4c81;
    background: #ffffff;
  }
  .pop-card__head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 14px;
    border-bottom: 1px solid #eef1f6;
    background: #fafbfd;
    position: sticky;
    top: 0;
    z-index: 3;
  }
  .pop-card__brand {
    display: inline-flex;
    align-items: center;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.8px;
    color: #5b6473;
    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas,
      monospace;
  }
  .pop-card__brand-dot {
    display: inline-block;
    width: 6px;
    height: 6px;
    background: #0f4c81;
    border-radius: 1px;
    margin-right: 8px;
  }
  .pop-card__close {
    margin: 0 !important;
  }
</style>
